module.exports = __webpack_public_path__ + "static/media/2-en.a26fd089.svg";